import React from "react";
import { PubMaterial, AwardStyle } from "./styles";
// import { useLocation } from "react-router-dom";

function parseOtherLinks(value) {
  if (typeof value !== "string") return [];
  const trimmed = value.trim();
  if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) return [];
  // Split on '],[' boundaries while keeping inner content
  const groups = trimmed
    .slice(1, -1) // remove outer [ ]
    .split(/\],\[/);
  const results = [];
  for (const group of groups) {
    const parts = group.split(/,\s*/);
    if (parts.length >= 2) {
      const label = parts[0].replace(/^\[|\]$/g, "").trim();
      const url = parts.slice(1).join(", ").replace(/^\[|\]$/g, "").trim();
      // Only accept absolute external URLs to avoid react-snap treating them as internal
      if (/^https?:\/\//i.test(url)) {
        results.push([label, url]);
      }
    }
  }
  return results;
}

const Award = ({ award, divider }) => {
  if (award) {
    return (
      <>
        {divider && " |  "} <AwardStyle>{award}</AwardStyle>
      </>
    );
  } else {
    return <></>;
  }
};

const BibTexLink = ({ bibTex, divider }) => {
  // const location = useLocation();
  if (bibTex) {
    return (
      <>
        {divider && " | "}
        <PubMaterial
          href={process.env.PUBLIC_URL + "/pubs/bibtex/" + bibTex[1] + "/"}
        >
          BibTeX
        </PubMaterial>
      </>
    );
  } else {
    return <></>;
  }
};

const Materials = ({ materials, award, bibTex }) => {
  let listMaterials = Object.entries(materials).filter((pair) => pair[1]);

  // Expand "Other links" which may be a bracketed list of pairs
  let expandedMaterials = [];
  for (const [key, value] of listMaterials) {
    if (key === "Other links") {
      const parsed = parseOtherLinks(value);
      if (parsed.length > 0) {
        for (const [label, url] of parsed) {
          expandedMaterials.push([label, url]);
        }
        continue; // skip pushing raw "Other links"
      }
      // If parsing fails, skip to avoid invalid hrefs breaking react-snap
      continue;
    }
    expandedMaterials.push([key, value]);
  }

  const itemsToRender = expandedMaterials;
  return (
    <>
      {itemsToRender.map((pair, index) => (
        <span key={index}>
          <PubMaterial key={index} href={pair[1]}>
            {pair[0]}
          </PubMaterial>
          {index !== itemsToRender.length - 1 ? " | " : ""}
        </span>
      ))}
      <BibTexLink bibTex={bibTex} divider={itemsToRender.length > 0} />
      <Award award={award} divider={itemsToRender.length > 0 || bibTex} />
    </>
  );
};

export default Materials;
